module.exports = __webpack_public_path__ + "media/assets/images/common/instagram-c4404857fd7ed02735837fcfe1a3a762.png";